<template>
  <div>
    <div class="ba-w-100 ba-grid ba-gp-08" v-if="website.id">
      <alert-box-component>
        <p slot="content">{{ $t('ct-info-split-test') }}</p>
      </alert-box-component>

      <div class="ba-w-100 ba-grid ba-gp-08">

        <div class="ba-w-100 ba-flex ba-gp-08 ba-ai-center ba-jc-fe">
          <button v-if="tests.length" class="ba-btn ba-md ba-red" @click="removeTest">
            {{ $t('ct-remove-split-test') }}
          </button>
          <button class="ba-btn ba-md ba-blue" data-ba-i="create-split-test" @click="showPopupAddTest">
            <builderall-icon code='2780'></builderall-icon>
            {{ $t('ct-new-split-test') }}
          </button>
        </div>

        <div class="ba-w-100 ba-grid ba-gp-08" v-for="(test, index) in tests" :key="index">
          <div class="ba-w-100 ba-grid ba-gp-08">
            <div class="ba-flex ba-ai-center ba-gp-04">
              <span class="ba-montserrat-500">{{ $t('ct-split-test-main') }}</span>
              <span class="ba-text-uppercase ba-montserrat-700"> {{ getPageName(test.main_page) }}</span>
            </div>
            <div class="ba-flex ba-ai-center ba-gp-04">
              <span class="ba-montserrat-500">{{ $t('ct-split-test-target') }}</span>
              <span class="ba-text-uppercase ba-montserrat-700"> {{ getPageName(test.target_page) }}</span>
            </div>
          </div>
          <div class="ba-w-100 ba-gp-08 ba-grid">
            <div class="ba-montserrat-500"> {{ $t('ct-split-variations') }}</div>
            <div class="ba-w-100" v-for="(variant, indexV) in test.variations"
              :key="indexV">
              <div  v-if="variant['page_id'] == test.main_page">
              <input 
                  type='text' 
                  class='ba-input ba-disabled ba-w-100 ba-md' 
                  disabled 
                  :placeholder='getPageName(variant["page_id"])' 
              />
            </div>
            <div v-else class="ba-card ba-w-100 ba-blue ba-no-shadow " style="height: 60px;">
              <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100 ">
                <span style="width: 150px;">
                  {{ getPageName(variant['page_id']) }}
                </span>
                <hr data-v-073a963e="" class="ba-hr-column" style="height: 30px;">
                <button  class='ba-btn ba-btn-trash ba-sm ba-rounded'
                  @click.prevent="deleteVariation(variant['page_id'], test.id)">
                  <builderall-icon code='trash' />
                </button>
              </div>
            </div>
            </div>
          </div>
          <div class="ba-w-100 ba-gp-08 ba-flex ba-ai-center ba-jc-fs">
            <button class="ba-btn ba-md ba-blue" @click.prevent="addPageInTest(test.id)">
              <builderall-icon code='2780'></builderall-icon>
              {{ $t('ct-split-add-page') }}
            </button>
          </div>
          <div class="ba-w-100 ba-flex ba-ai-center ba-jc-sb">
              <span class="ba-montserrat-500">
                {{ $t('ct-split-test-view-data') }}
              </span>
              <button class="ba-btn ba-md ba-dark" @click.prevent="viewData(test.id)" data-ba-i="view-data-split-test">
                {{ $t('ct-split-test-view-data-button') }}
              </button>
          </div>
          <hr class="ba-hr-row" v-if="index + 1 < tests.length">
        </div>
      </div>
    </div>

    <sweet-modal ref="addTest" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-new-split-test') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closePoup">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row '>
      <div class="ba-grid ba-mg-y-1 ba-gp-1">
        <div class="ba-grid">
          <label class="ba-custom-label">{{ $t('ct-split-test-main') }}</label>
          <select v-model="originPage" class="ba-select ba-md">
            <option value="all">None</option>
            <option v-for="page in pages" :key="page.id" :value="page.id">{{ page.title }}</option>
          </select>
        </div>
        <div class="ba-grid">
          <label class="ba-custom-label">{{ $t('ct-split-test-target') }}</label>
          <select v-model="targetPage" class="ba-select ba-md">
            <option value="all">None</option>
            <option v-for="page in pages" :key="page.id" :value="page.id">{{ page.title }}</option>
          </select>
        </div>
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button slot="button" class="ba-btn ba-md ba-light" @click="closePoup">{{
          $t('ct-cancel')}}</button>
        <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="saveTest">{{ $t('ct-save')
          }}</button>
      </div>
    </sweet-modal>

    <sweet-modal ref="addPage" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-split-add-page') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closePoup">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1">
        <label class="ba-custom-label">{{ $t('ct-split-new-variation') }}</label>
        <select v-model="newPage" class="ba-select ba-md">
          <option value="all">None</option>
          <option v-for="page in pages" :key="page.id" :value="page.id" v-if="itemsContains(page.id)">{{
            page.title
            }}
          </option>
        </select>
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button slot="button" class="ba-btn ba-md ba-light" @click="closePoup">{{
          $t('ct-cancel')}}</button>
        <button slot="button" class="ba-btn ba-md ba-blue"  @click.prevent="saveTestPage">{{ $t('ct-save')
          }}</button>
      </div>
    </sweet-modal>

    <sweet-modal ref="removeTest" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-remove-split-test') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closePoup">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1 ba-gp-08">
        <div class="ba-card ba-w-100 ba-blue ba-no-shadow" v-for="(test, index) in tests" :key="index" style="height: 60px;">
          <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100">
            <div class="ba-flex ba-ai-center ba-gp-04" style="width: 300px;">
              <span class="ba-montserrat-600 ba-text-14">{{ $t('ct-split-test-main') }}</span>
              <span class="ba-text-uppercase ba-montserrat-700 ba-text-14"> {{ getPageName(test.main_page) }}</span>
            </div>
            <hr class="ba-hr-column" style="height: 30px;">
            <div class="ba-flex ba-ai-center ba-gp-04" style="width: 300px;">
              <span class="ba-montserrat-600 ba-text-14">{{ $t('ct-split-test-target') }}</span>
              <span class="ba-text-uppercase ba-montserrat-700 ba-text-14"> {{ getPageName(test.target_page) }}</span>
            </div>
            <hr class="ba-hr-column" style="height: 30px;">
            <button class="ba-btn ba-btn-trash ba-sm ba-rounded" @click.prevent="removeTestById(test.id)">
              <builderall-icon code='trash' />
            </button>
          </div>
        </div>
      </div>
    </sweet-modal>

    <sweet-modal ref="viewData" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-split-test-view-data') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closePoup">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1 ba-gp-08">
        <div class="ba-card ba-no-shadow ba-w-100" style="background-color: #eff2f8;">
          <div class="ba-w-100 ba-flex ba-ai-center ba-jc-sb">
              <span class="ba-montserrat-600" style="width: 150px;">{{ $t('ct-tests-view-page') }}</span>
                <span class="ba-montserrat-600">{{ $t('ct-tests-view-access') }}</span>
                <span class="ba-montserrat-600">{{ $t('ct-tests-view-forward') }}</span>
                <span class="ba-montserrat-600">%</span>
          </div>
        </div>
        <div class="ba-card ba-w-100 ba-blue ba-no-shadow " v-for="(split, index) in dataSplit" :key="index" style="height: 60px;">
              <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100">
                <span class="ba-montserrat-600" style="width: 150px;">
                  {{ split.page }}
                </span>
                <hr class="ba-hr-column" style="height: 30px;">
                <span class="ba-montserrat-600">{{ split.access }}</span>
                <hr class="ba-hr-column" style="height: 30px;">
                <span class="ba-montserrat-600">{{ split.forward }}</span>
                <hr class="ba-hr-column" style="height: 30px;">
                <span class="ba-montserrat-600">{{ getPer(split) + '%' }}</span>
              </div>
            </div>
          <div class='ba-w-100'>
          <alert-box-component>
            <p slot="content">{{ $t('ct-tests-view-helper') }}</p>
          </alert-box-component>
        </div>
      </div>
    </sweet-modal>

  </div>
</template>

<script>

import NavComponent from '../layout/nav/Nav';
import Errors from "../../../js/base/Errors.js";
import { get as getWebsite, getSplitTest } from "../../../js/services/editor/website.js";
import SiteSidebarComponent from "../layout/site/SiteSidebar";
import AlertBoxComponent from '../../commons/AlertBoxComponent';
import { SweetModal } from 'sweet-modal-vue';
import { addPage, addTest, deletePage, deleteTest, getDataTests } from "../../../js/services/editor/splitTests.js";

require('../../../../static/charts/dist/Chart.bundle.min.js');

export default {
  name: 'SplitTest',
  components: {
    NavComponent,
    SiteSidebarComponent,
    AlertBoxComponent,
    SweetModal
  },
  data() {
    return {
      errors: new Errors(),
      website: {},
      originPage: null,
      targetPage: null,

      newPage: null,
      newPageTestId: null,

      tests: [],
      pages: [],

      ignorePages: [],

      dataSplit: []
    };
  },

  methods: {

    itemsContains(n) {
      return this.ignorePages.indexOf(n) === -1
    },

    closePoup() {
      this.$refs.addPage.close();
      this.$refs.addTest.close();
      this.$refs.viewData.close();
      this.$refs.removeTest.close();
    },

    showPopupAddTest() {
      this.$refs.addTest.open();

      this.originPage = "all";
      this.targetPage = "all";
    },

    saveTest() {

      if (this.originPage === null || this.originPage === "all") {
        this.$snotify.error(this.$t('ct-split-test-error-no-origin'));
      }

      if (this.targetPage === null || this.targetPage === "all") {
        this.$snotify.error(this.$t('ct-split-test-error-no-target'));
      }

      if (this.originPage === this.targetPage) {
        this.$snotify.error(this.$t('ct-split-test-error-same-page'));
      }

      if (
        this.originPage !== null &&
        this.targetPage !== null &&
        this.originPage !== "all" &&
        this.targetPage !== "all" &&
        this.originPage !== this.targetPage
      ) {
        addTest({
          originPage: this.originPage,
          targetPage: this.targetPage,
          layout: this.website.layout
        }).then(() => {
          this.$snotify.success(this.$t('ct-success-true'));
          this.getDataToFill();
        })
      }
    },

    saveTestPage() {

      if (this.newPage === null || this.newPage === "all") {
        this.$snotify.error(this.$t('ct-split-test-error-need-page'));
      } else {
        addPage({
          page_id: this.newPage,
          test_id: this.newPageTestId
        }).then(() => {
          this.$snotify.success(this.$t('ct-success-true'));
          this.getDataToFill();
        })
      }

    },

    deleteVariation(page_id, test_id) {

      deletePage({
        page_id: page_id,
        test_id: test_id
      }).then(() => {
        this.$snotify.error(this.$t('ct-deleted-true'));
        this.getDataToFill();
      })
    },

    getPer(split) {
      if (split.access !== 0) {
        return (split.forward * 100 / split.access).toFixed(0);
      }
      return 0;
    },

    viewData(test_id) {

      this.$refs.viewData.open();

      let labels = [];
      let dataSet = [];

      $('.polar-chart').empty();

      getDataTests(test_id).then(response => {
        this.dataSplit = response.data;

        this.dataSplit.forEach((split) => {
          labels.push(split.page);
          dataSet.push(this.getPer(split));
        })


        let canvasContainer = $('<canvas>').appendTo($('.polar-chart').get(0));
        let ctx = canvasContainer.get(0).getContext('2d');
        new Chart(ctx, {
          type: 'polarArea',
          data: {
            labels: labels,
            datasets: [{
              data: dataSet,
              borderColor: 'white',
              backgroundColor: [
                '#142459',
                '#176BA0',
                '#19AADE',
                '#1DE4BD',
                '#7D3AC1',
                '#AF4BCE',
                '#DB4CB2',
                '#EA7369',
                '#820401',
                '#C02323',
                '#EF7E32',
                '#EE9A3A',
                '#E7E34E'
              ]
            }]
          },
        });
      })

    },

    addPageInTest(test_id) {
      this.newPageTestId = test_id;
      this.newPage = "all";

      this.ignorePages = [];

      for (let i in this.tests) {
        if (this.tests[i].id === test_id) {
          this.ignorePages.push(this.tests[i].main_page)
          this.ignorePages.push(this.tests[i].target_page)

          for (let j in this.tests[i].variations) {
            this.ignorePages.push(this.tests[i].variations[j]['page_id']);
          }
        }
      }

      this.$refs.addPage.open();
    },

    removeTest() {
      this.$refs.removeTest.open();
    },

    removeTestById(id) {
      console.log(id);
      deleteTest({
        test_id: id
      }).then(() => {
        this.$snotify.error(this.$t('ct-deleted-true'));
        this.getDataToFill();
      })

    },

    getPageName(id) {
      let pageName = '';
      for (let i in this.pages) {
        if (this.pages[i].id == id) {
          pageName = this.pages[i].title;
        }
      }
      return pageName;
    },

    getDataToFill() {
      getSplitTest(this.$route.params.id)
        .then(data => {
          this.tests = data.data.data;
          this.pages = data.data.pages;

          this.closePoup();
        })
    },
  },

  async created() {
    this.$emit('loading', true);
    getWebsite(this.$route.params.id)
      .then(website => {
        this.website = website.data;
        this.website.layout = this.website.layouts[0];
        this.$emit('loading', false);
      })
      .finally(() => this.$emit('loading', false));

    getSplitTest(this.$route.params.id)
      .then(data => {
        this.tests = data.data.data;
        this.pages = data.data.pages;
      })
  }
};

</script>

<style lang="scss" scoped>
.labelspacing {
  padding-left: 30px;
  padding-right: 60px;
}

.left {
  left: 30px;
}

.header-text {
  .lighter {
    margin-left: 20px;
    margin-right: 0px;
  }
}

.bolder-bolder {
  font-family: 'Muli', sans-serif;
  font-size: 18px;
  font-weight: bold;
}

.lighter,
.bolder {
  color: black;
}

.lighter {
  font-weight: 400;
  font-size: 15px;
}

.w-60 {
  width: 60% !important;
}

.w-40 {
  width: 40% !important;
}

.split-test-row {

  .btn-add-page {
    position: absolute;
    top: 30px;
    right: 30px;
  }

  .header-text {
    font-family: 'Muli', sans-serif;
    font-size: 18px;
    font-weight: bold;

    color: #0080FC;

    &.variation-text {
      margin-top: 10px;
      font-size: 18px;
      color: #040404;
      font-weight: 500;
    }
  }

  .place-page {
    background: #FAFBFC 0% 0% no-repeat padding-box;
    border: 1px solid #DDDDDD;
    border-radius: 3px;
    opacity: 1;
    padding: 15px;
    margin-bottom: 15px;
  }

  .icon-delete {
    font-size: 20px;
    color: red;
    cursor: pointer;
    float: right;
  }
}

.cheetah-seo-settings {
  &__header {
    padding-top: 35px;

    h1 {
      font-family: 'Muli', sans-serif;
      font-size: 25px;
      font-weight: bold;

      color: #0080FC;
    }
  }

  &__content {
    .form-group {
      label {
        font-family: 'Muli', sans-serif;
        font-size: 16px;
        color: #5A5959;
      }

      input {
        height: 46px;
      }

      textarea {
        resize: none;
      }

      input,
      textarea {
        font-family: 'Muli', sans-serif;
        font-size: 13px;

        color: #656565;
        background: #FAFBFC;
        border-color: #E0E0E0;

        transition: all 0.2s;

        &:focus {
          outline: none;
          border-color: #0080FC;
          box-shadow: none;
        }
      }
    }
  }

  &__illustration {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 480px;

    margin-left: 25px;

    img {
      width: 100%;
    }
  }

  .card {
    margin-top: 15px;

    &-header {
      font-family: 'Muli', sans-serif;
      font-size: 20px;
      font-weight: 600;
      text-transform: uppercase;

      color: #333333;
      background-color: #F7F7F7;

      box-shadow: 0px 6px 3px #7E7E7E10;
      padding: 24px 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/SplitTest.vue